module.exports = __webpack_public_path__ + "assets/icons/account-circle-93fc.svg";